export function prepareLDAPConfig(config) {
  const userPasswd = config.user_passwd;
  if (userPasswd && "is_set" in userPasswd) {
    return {
      ...config,
      user_passwd: userPasswd.is_set ? { keep_value: true } : { set_value: "" }
    };
  }
  return config;
}
